import { combineReducers } from 'redux';
import {
	filterRequestsByReviewable,
	filterRequestsByOwned,
  filterRequestsByCategory,
  filterRequestsByStatus,
  filterOutRequestsByCategory,
} from '../utils/functions';

// small function to fix a bad data formatting issue?
function getResults(result){
	if(typeof result === 'undefined') return [];
	return result
}

const allRequests = (state = [], action) => {
  switch (action.type) {
    case 'FETCH_ALL_VENDOR_REQUESTS_FULFILLED':
      return action.payload.data;
    case 'FETCH_ALL_VENDOR_REQUESTS_REJECTED':
      return [];
    default:
      return state;
  }
};

const allRequestsReviewable = (state = [], action) => {
	switch (action.type) {
	  case 'FETCH_ALL_VENDOR_REQUESTS_FULFILLED':
		const dataSet = getResults(action.payload.data['result']);
		let filteredData = filterRequestsByReviewable(dataSet);
		return { totalCount: filteredData.length, result: filteredData };
	  default:
		return state;
	}
  };

	const onlyMyRequests = (state = [], action) => {
		switch (action.type) {
			case 'FETCH_ALL_VENDOR_REQUESTS_FULFILLED':
			const dataSet = getResults(action.payload.data['result']);
			let filteredData = filterRequestsByOwned(dataSet);
			return { totalCount: filteredData.length, result: filteredData };
			default:
			return state;
		}
		};

const allRequestsInProgress = (state = [], action) => {
  switch (action.type) {
    case 'FETCH_ALL_VENDOR_REQUESTS_FULFILLED':
      const dataSet = getResults(action.payload.data['result']);
      let filteredData = filterRequestsByCategory(dataSet, 'pending');
      return { totalCount: filteredData.length, result: filteredData };
    default:
      return state;
  }
};

const allRequestsNotInProgress = (state = [], action) => {
  switch (action.type) {
    case 'FETCH_ALL_VENDOR_REQUESTS_FULFILLED':
      const dataSet = getResults(action.payload.data['result']);
      let filteredData = filterOutRequestsByCategory(dataSet, 'pending');
      return { totalCount: filteredData.length, result: filteredData };
    default:
      return state;
  }
};

const allRequestsInReview = (state = [], action) => {
  switch (action.type) {
    case 'FETCH_ALL_VENDOR_REQUESTS_FULFILLED':
      const dataSet = getResults(action.payload.data['result']);
      let filteredData = filterRequestsByCategory(dataSet, 'review');
      return { totalCount: filteredData.length, result: filteredData };
    default:
      return state;
  }
};

const allRequestsPassed = (state = [], action) => {
  switch (action.type) {
    case 'FETCH_ALL_VENDOR_REQUESTS_FULFILLED':
      const dataSet = getResults(action.payload.data['result']);
      let filteredData = filterRequestsByCategory(dataSet, 'pass');
      return { totalCount: filteredData.length, result: filteredData };
    default:
      return state;
  }
};

const allRequestsUpcomingApprovals = (state = [], action) => {
  switch (action.type) {
    case 'FETCH_ALL_UPCOMING_RENEWAL_VENDOR_REQUESTS_FULFILLED':
      return action.payload.data;
    case 'FETCH_ALL_UPCOMING_RENEWAL_VENDOR_REQUESTS_REJECTED':
      return [];
    default:
      return state;
  }
};

const allRequestsBelowThreshold = (state = [], action) => {
  switch (action.type) {
    case 'FETCH_ALL_VENDOR_REQUESTS_FULFILLED':
      const dataSet = getResults(action.payload.data['result']);
      let filteredData = filterRequestsByStatus(
        dataSet,
        'Below Threshold, Needs Review'
      );
      return { totalCount: filteredData.length, result: filteredData };
    default:
      return state;
  }
};

const allRequestsAutoFailDocumentation = (state = [], action) => {
  switch (action.type) {
    case 'FETCH_ALL_VENDOR_REQUESTS_FULFILLED':
      const dataSet = getResults(action.payload.data['result']);
      let filteredData = filterRequestsByStatus(
        dataSet,
        'Auto Fail - Documentation'
      );
      return { totalCount: filteredData.length, result: filteredData };
    default:
      return state;
  }
};

const allRequestsAutoFailQuestions = (state = [], action) => {
  switch (action.type) {
    case 'FETCH_ALL_VENDOR_REQUESTS_FULFILLED':
      const dataSet = getResults(action.payload.data['result']);
      let filteredData = filterRequestsByStatus(
        dataSet,
        'Auto Fail - Question(s)'
      );
      return { totalCount: filteredData.length, result: filteredData };
    default:
      return state;
  }
};

const allRequestsThirdPartyDispute = (state = [], action) => {
  switch (action.type) {
    case 'FETCH_ALL_VENDOR_REQUESTS_FULFILLED':
      const dataSet = getResults(action.payload.data['result']);
      let filteredData = filterRequestsByStatus(dataSet, 'Third Party Dispute');
      return { totalCount: filteredData.length, result: filteredData };
    default:
      return state;
  }
};

const allRequestsLoaded = (state = false, action) => {
  switch (action.type) {
    case 'FETCH_ALL_VENDOR_REQUESTS_FULFILLED':
    case 'FETCH_ALL_VENDOR_REQUESTS_REJECTED':
      return true;
    case 'FETCH_ALL_VENDOR_REQUESTS_PENDING':
      return false;
    default:
      return state;
  }
};

const allRequestsFetching = (state = false, action) => {
  switch (action.type) {
    case 'FETCH_ALL_VENDOR_REQUESTS_PENDING':
      return true;
    case 'FETCH_ALL_VENDOR_REQUESTS_REJECTED':
    case 'FETCH_ALL_VENDOR_REQUESTS_FULFILLED':
      return false;
    default:
      return state;
  }
};

const allRequestsByUserType = (state = [], action) => {
  switch (action.type) {
    case 'FETCH_VENDOR_REQUESTS_BY_USER_TYPE_FULFILLED':
      return action.payload.data;
    case 'FETCH_VENDOR_REQUESTS_BY_USER_TYPE_REJECTED':
      return [];
    default:
      return state;
  }
};

const userTypeRequestsLoaded = (state = false, action) => {
  switch (action.type) {
    case 'FETCH_VENDOR_REQUESTS_BY_USER_TYPE_FULFILLED':
    case 'FETCH_VENDOR_REQUESTS_BY_USER_TYPE_REJECTED':
      return true;
    case 'FETCH_VENDOR_REQUESTS_BY_USER_TYPE_PENDING':
      return false;
    default:
      return state;
  }
};

const userTypeRequestsFetching = (state = false, action) => {
  switch (action.type) {
    case 'FETCH_VENDOR_REQUESTS_BY_SPONSOR_FULFILLED':
    case 'FETCH_VENDOR_REQUESTS_BY_SPONSOR_REJECTED':
      return false;
    case 'FETCH_VENDOR_REQUESTS_BY_SPONSOR_PENDING':
      return true;
    default:
      return state;
  }
};

const singleRequest = (state = {}, action) => {
  switch (action.type) {
    case 'FETCH_VENDOR_REQUEST_FULFILLED':
      return action.payload.data.result[0];
    case 'FETCH_VENDOR_REQUEST_REJECTED':
      return {};
    default:
      return state;
  }
};

const history = (state = [], action) => {
  switch (action.type) {
    case 'FETCH_HISTORY_FULFILLED':
      return action.payload.data;
    case 'FETCH_HISTORY_REJECTED':
      return [];
    default:
      return state;
  }
};

const requestLoaded = (state = false, action) => {
  switch (action.type) {
    case 'FETCH_VENDOR_REQUEST_FULFILLED':
    case 'FETCH_VENDOR_REQUEST_REJECTED':
      return true;
    case 'FETCH_VENDOR_REQUEST_PENDING':
      return false;
    default:
      return state;
  }
};
const requestLoading = (state = false, action) => {
  switch (action.type) {
    case 'FETCH_VENDOR_REQUEST_FULFILLED':
    case 'FETCH_VENDOR_REQUEST_REJECTED':
      return false;
    case 'FETCH_VENDOR_REQUEST_PENDING':
      return true;
    default:
      return state;
  }
};

const requestError = (state = { isError: false, message: '' }, action) => {
  switch (action.type) {
    case 'FETCH_VENDOR_REQUEST_REJECTED':
      return { isError: true, message: action.payload.response.data.message };
    case 'FETCH_VENDOR_REQUEST_PENDING':
    case 'FETCH_VENDOR_REQUEST_FULFILLED':
      return { isError: false, message: '' };
    default:
      return state;
  }
};

const vendorDetails = (state = {}, action) => {
  switch (action.type) {
    case 'FETCH_VENDOR_DETAILS_FULFILLED':
      return action.payload.data;
    case 'FETCH_VENDOR_DETAILS_REJECTED':
      return {};
    default:
      return state;
  }
};

const vendors = (state = [], action) => {
  switch (action.type) {
    case 'FETCH_VENDOR_REQUEST_VENDOR_FULFILLED':
      return action.payload.data;
    case 'FETCH_VENDOR_REQUEST_VENDOR_REJECTED':
      return [];
    default:
      return state;
  }
};

const isVendorsLoaded = (state = false, action) => {
  switch (action.type) {
    case 'FETCH_VENDOR_REQUEST_VENDOR_PENDING':
      return false;
    case 'FETCH_VENDOR_REQUEST_VENDOR_FULFILLED':
    case 'FETCH_VENDOR_REQUEST_VENDOR_REJECTED':
      return true;
    default:
      return state;
  }
};

const products = (state = [], action) => {
  switch (action.type) {
    case 'FETCH_VENDOR_REQUEST_PRODUCT_FULFILLED':
      return action.payload.data;
    case 'FETCH_VENDOR_REQUEST_PRODUCT_REJECTED':
      return [];
    case 'CLEAR_VENDOR_REQUEST_PRODUCT':
      return action.payload;
    default:
      return state;
  }
};

const contacts = (state = [], action) => {
  switch (action.type) {
    case 'FETCH_VENDOR_CONTACTS_FULFILLED':
      return action.payload.data.result;
    case 'FETCH_VENDOR_CONTACTS_REJECTED':
      return [];
    case 'CLEAR_VENDOR_CONTACTS':
      return action.payload;
    default:
      return state;
  }
};

const comments = (state = [], action) => {
  switch (action.type) {
    case 'FETCH_VENDOR_REQUEST_COMMENTS_FULFILLED':
      return action.payload.data;
    case 'FETCH_VENDOR_REQUEST_COMMENTS_REJECTED':
      return [];
    default:
      return state;
  }
};

const isFetchingComments = (state = false, action) => {
  switch (action.type) {
    case 'FETCH_VENDOR_REQUEST_COMMENTS_PENDING':
      return true;
    case 'FETCH_VENDOR_REQUEST_COMMENTS_FULFILLED':
    case 'FETCH_VENDOR_REQUEST_COMMENTS_REJECTED':
      return false;
    default:
      return state;
  }
};

const isErrorComments = (state = null, action) => {
  switch (action.type) {
    case 'FETCH_VENDOR_REQUEST_COMMENTS_PENDING':
    case 'FETCH_VENDOR_REQUEST_COMMENTS_FULFILLED':
      return null;
    case 'FETCH_VENDOR_REQUEST_COMMENTS_REJECTED':
      return action.payload.message;
    default:
      return state;
  }
};

const isFetching = (state = false, action) => {
  switch (action.type) {
    case 'FETCH_VENDOR_REQUEST_VENDOR_PENDING':
    case 'FETCH_VENDOR_REQUEST_PENDING':
    case 'FETCH_VENDOR_DETAILS_PENDING':
      return true;
    case 'FETCH_VENDOR_REQUEST_VENDOR_REJECTED':
    case 'FETCH_VENDOR_REQUEST_VENDOR_FULFILLED':
    case 'FETCH_VENDOR_REQUEST_REJECTED':
    case 'FETCH_VENDOR_REQUEST_FULFILLED':
    case 'FETCH_VENDOR_DETAILS_REJECTED':
    case 'FETCH_VENDOR_DETAILS_FULFILLED':
      return false;
    default:
      return state;
  }
};

const isErrorAllRequests = (state = false, action) => {
  switch (action.type) {
    case 'FETCH_ALL_VENDOR_REQUESTS_FULFILLED':
      return false;
    case 'FETCH_ALL_VENDOR_REQUESTS_REJECTED':
      return true;
    default:
      return state;
  }
};

const filters = (state = [], action) => {
  switch (action.type) {
    case 'FETCH_REQUEST_FILTERS_FULFILLED':
      return action.payload.data.result;
    default:
      return state;
  }
};

const isFiltersLoaded = (state = false, action) => {
  switch (action.type) {
    case 'FETCH_REQUEST_FILTERS_PENDING':
      return false;
    case 'FETCH_REQUEST_FILTERS_FULFILLED':
    case 'FETCH_REQUEST_FILTERS_REJECTED':
      return true;
    default:
      return state;
  }
};

const exports = (state = [], action) => {
  switch (action.type) {
    case 'FETCH_ALL_VENDOR_REQUESTS_EXPORT_FULFILLED':
			if(typeof action.payload.data.result === 'undefined') return []; // no results
      return action.payload.data.result;
    default:
      return state;
  }
};

const exportsLoaded = (state = false, action) => {
  switch (action.type) {
    case 'FETCH_ALL_VENDOR_REQUESTS_EXPORT_FULFILLED':
      return true;
    case 'FETCH_ALL_VENDOR_REQUESTS_EXPORT_PENDING':
      return false;
    default:
      return state;
  }
};

const vendorRequest = combineReducers({
  allRequests,
  allRequestsLoaded,
  allRequestsFetching,
  allRequestsByUserType,
  userTypeRequestsLoaded,
  userTypeRequestsFetching,
  allRequestsReviewable,
	onlyMyRequests,
  allRequestsInProgress,
  allRequestsNotInProgress,
  allRequestsInReview,
  allRequestsPassed,
  allRequestsUpcomingApprovals,
  allRequestsBelowThreshold,
  allRequestsAutoFailQuestions,
  allRequestsAutoFailDocumentation,
  allRequestsThirdPartyDispute,
  singleRequest,
  history,
  requestLoaded,
  requestLoading,
  requestError,
  vendorDetails,
  vendors,
  products,
  contacts,
  comments,
  isFetchingComments,
  isErrorComments,
  isFetching,
  isErrorAllRequests,
  filters,
  isFiltersLoaded,
  exports,
  exportsLoaded,
  isVendorsLoaded,
});

export default vendorRequest;
